var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "268mm",
    height: "73.5mm",
    viewBox: "0 0 268 73.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 202.24,
    x2: 215.92,
    y1: 188.32,
    y2: 175.61,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4d00",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9b0f",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 201.4,
    x2: 214.5,
    y1: 190.4,
    y2: 177.74,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 214.5,
    x2: 201.4,
    y1: 177.74,
    y2: 190.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9b0f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4d01",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 206.33,
    x2: 220.04,
    y1: 122.81,
    y2: 111.01,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 48.024,
    cy: 48.019,
    r: 47.598,
    gradientTransform: "matrix(1 0 0 1.0005 255.87 255.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00004d",
    stopOpacity: 0.6,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00004c",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 3306.9,
    x2: 2795.7,
    y1: -853.1,
    y2: -320.59,
    gradientTransform: "matrix(.13532 0 0 .13418 -110.32 383.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9b0f",
    offset: 0.2322
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4d00",
    offset: 0.61314
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.082478 0 0 -.0822 -48.868 173.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2580 1923v-83h-71l3-47c3-47 3-48 35-45l31 3 4-180c3-163 5-182 24-208 29-39 80-63 138-63 42 0 47 2 41 18-4 9-9 32-12 50-5 25-10 32-29 32-13 0-33 9-44 20-18 18-20 33-20 176v156l35-6 35-7v101h-70v165l-50 1h-50zm70-9c0-48 4-59 30-86 17-16 30-32 30-35s-14-18-31-34l-31-29 4-151 3-151 43-37c23-20 42-42 42-49 0-17-35-15-71 4-49 25-59 64-59 234v152l-30 30c-30 30-38 48-20 48 26 0 50 45 50 95 0 54 5 65 27 65 9 0 13-16 13-56z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3260 1649v-357h101l-1 206c-1 201-1 207 20 224 12 10 28 18 36 18 10 0 14 14 14 50v50l-36-15c-20-8-39-15-41-15-3 0-4 42-1 94l4 94-48 4-48 3zm60 254c0-55 4-71 22-90 12-13 30-23 40-23 25 0 23-15-5-37-46-35-51-59-53-228-1-88-3-168-3-177-1-10-8-18-16-18-13 0-15 41-15 313 0 173 3 317 7 320 17 18 23 2 23-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1660 1960c0-22 48-149 129-345l130-310 38-3 39-3 57 130 57 129v123c0 71-4 119-9 114-9-11-141-318-141-330 0-23 38 30 66 91 18 40 37 74 41 77 5 3 10-11 11-32 2-25-11-69-43-140-50-115-62-133-82-129-16 3-265 584-260 608 4 27 31 16 48-20 10-19 32-71 49-115 18-44 40-98 50-120 9-22 27-67 40-100 26-67 80.387-136.19 85.387-120.19 2 6-60.387 136.19-116.39 273.19l-103 250-43 4-43 3z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2160 1648v-348h110v688l-55 4-55 3zm77 7c2-165-1-306-6-314s-16-11-25-8c-14 6-16 41-16 317v311l23-3 22-3z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2366 1987c-11-8-18-26-18-42 0-50 62-74 95-37 19.834 21.944 19.188 46.738 7.607 64.986-15.862 24.994-52.239 37.711-84.607 14.014zm58-48c-3-5-14-9-25-9-21 0-26 26-6 33 15 5 39-12 31-24z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3736 1987c-11-8-18-26-18-42 0-50 62-74 95-37 47 52-21 120-77 79zm54-42c0-8-9-15-20-15-20 0-26 11-13 23 12 13 33 7 33-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2936 1840c-37-12-85-56-102-97-10-22-14-75-14-170 0-113 4-145 19-179 22-48 66-83 116-91l35-6v52c0 43-3 51-18 51-11 0-26 8-35 18-14 15-17 42-17 155 0 124 2 139 20 157 11 11 27 20 35 20 11 0 15 12 15 50 0 53-2 55-54 40zm1-76c-41-38-47-63-47-189 0-124 8-158 46-194 34-32 17-53-24-29-50 30-57 59-57 225 0 138 2 154 21 180 26 35 65 56 79 42 6-6 0-18-18-35z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3040 1803c0-43 3-50 30-65 23-13 30-24 30-48 0-18 3-30 8-28 4 2 24 10 45 18 37 14 39 17 33 49-5 33-44 84-76 100-8 5-27 11-42 15-28 6-28 6-28-41zm87-25c22-20 32-68 15-68-11 0-56 51-65 73-9 25 21 22 50-5z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2350 1570v-270h105v540h-105zm72 218c7-38 3-446-4-453-4-4-14-5-23-1-13 5-15 36-15 235 1 126 4 232 7 235 13 13 31 5 35-16z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3480 1789c0-37 4-49 15-49 8 0 24-9 35-20 19-19 20-33 20-226v-205l92 6-1 220c-1 195-3 223-19 244-27 36-64 61-105 71l-37 8zm104-30c25-30 26-35 27-170 1-274 2-259-16-259-13 0-15 27-15 181 0 170-1 183-22 212-12 18-28 36-35 40-21 13-15 27 11 27 15 0 34-12 50-31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3720 1570v-270h105v540h-105zm71 228c5-45 8-391 3-425-5-44-26-58-38-26-8 19-7 429 1 449 6 17 32 19 34 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1660 1542v-242h110v227l-51 124c-28 68-53 126-55 128s-4-104-4-237zm64 13c16-44 20-194 7-214-5-8-16-11-25-8-14 5-16 27-16 144 0 142 7 158 34 78z",
    fill: "#ff9b0f",
    stroke: "#ff9b0f",
    strokeMiterlimit: 2.1,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3110 1461c0-30-27-61-53-61-14 0-17-10-17-50 0-56 7-60 63-36 39 16 97 79 97 106 0 11 0 23 1 27 0 3-20 14-45 24l-46 17zm53-51c-5-20-57-70-73-70-23 0-18 24 12 54 39 39 69 47 61 16z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m411.13 95.03c-0.73123-0.73122-1.1154-1.6368-1.2924-3.0464-0.69601-5.543-0.68146-47.117 0.0196-55.997 0.19609-2.4839 0.46939-3.2409 1.3919-3.8553 0.98284-0.65463 2.4894-0.48206 3.0055 0.34426 0.32908 0.52693 0.50532 3.8195 0.72189 13.486 0.23986 10.706 0.24698 39.544 0.0105 42.563-0.29142 3.7213-1.015 5.8352-2.3008 6.7213-0.61693 0.4252-0.96248 0.3771-1.5562-0.21663z",
    stroke: "#000",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.636
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m349.41 95.2c-1.2324-1.2324-1.4472-6.9344-1.4521-38.543-4e-3 -23.191 0.17859-37.035 0.56288-42.78l0.17146-2.5633 0.57008-0.48614c0.31355-0.26738 0.69997-0.48614 0.85872-0.48614 1.0762 0 1.57 2.6229 1.5806 8.3969 6e-3 3.4685 0.23559 6.8658 0.55187 8.1799 0.40943 1.7012 1.2075 3.0589 2.6178 4.4532 2.0256 2.0027 3.9938 3.0116 5.8749 3.0116 0.43282 0 0.8211 0.13967 1.1322 0.40726 0.39815 0.34247 0.45389 0.4964 0.35038 0.96764-0.16448 0.74887-1.3069 1.9874-3.5511 3.8499-4.0816 3.3874-5.2268 6.0928-5.9073 13.955-0.22372 2.5847-0.46335 11.783-0.72299 27.754-0.17602 10.827-0.22635 12.091-0.50684 12.728-0.34822 0.7907-0.60049 1.0442-1.3059 1.3124-0.39888 0.15166-0.5432 0.12413-0.82457-0.15723z",
    stroke: "#000",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.2357
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m388.24 95.425c-0.36014-0.09392-0.71954-0.72414-0.98877-1.7338-0.44828-1.6812-0.58974-6.1789-0.73669-23.423-0.087-10.211-0.23426-18.814-0.33735-19.711-0.26904-2.3398-0.68857-4.106-1.2597-5.3033-1.0917-2.2886-4.1965-6.176-6.0015-7.514-1.7112-1.2685-2.0231-2.1386-1.0312-2.8763 0.61462-0.45713 2.6536-0.61796 3.7924-0.29914 2.399 0.67167 6.083 4.2169 7.4226 7.1429 1.1539 2.5205 1.2981 5.272 1.4227 27.146 0.10289 18.068-7e-3 24.065-0.47015 25.675-0.25681 0.89237-0.79899 1.1605-1.8123 0.89623z",
    stroke: "#000",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.2357
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m129.9 71.55c0.11758-29.847 0.23257-35.77 0.70354-36.241 0.3759-0.3759 0.75186-0.17287 1.1595 0.62614 0.71391 1.3994 4.7292 10.89 9.2884 21.954l4.6965 11.397v30.857h-15.961zm9.1311 22.627c0.7307-0.662 1.0074-2.076 1.2433-6.3538 0.30083-5.4554-0.18033-14.001-1.0648-18.914-0.38388-2.1319-1.4339-5.3878-2.4267-7.5245-0.65269-1.4048-0.83864-1.6007-1.0069-1.0607-0.51578 1.655-0.85837 11.789-0.71266 21.081 0.14624 9.3244 0.44414 12.226 1.3294 12.949 0.24552 0.20049 0.68204 0.30936 1.2404 0.30936 0.6919 0 0.96715-0.09571 1.3981-0.48614z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.68667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m136.49 94.15c-0.83962-0.92776-1.0982-3.5575-1.2532-12.745-0.15484-9.1771 0.24087-20.536 0.73264-21.031 0.14246-0.1434 0.38906 0.36715 1.3004 2.6923 1.0216 2.6063 1.4866 4.1938 1.8634 6.3605 1.2896 7.4162 1.4225 21.128 0.23299 24.052-0.38777 0.95331-2.2316 1.3836-2.8762 0.67129z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.66667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m168.52 92.012c-5.2504-9.5406-27.119-60.56-31.682-73.915-1.025-2.9997-1.2076-3.9073-0.90152-4.4793 0.35742-0.66785 0.45424-0.68098 1.4032-0.19027 0.56058 0.28989 1.3586 1.0036 1.7734 1.5861 1.6319 2.2918 5.4812 11.302 17.325 40.555 1.9031 4.7005 4.2726 10.089 5.2655 11.976 3.2108 6.099 7.5505 11.475 9.2634 11.475 1.7482 0 4.6612-4.3944 10-15.086 1.8614-3.7275 3.5374-6.8719 3.7245-6.9875 0.1926-0.11903 0.44488 0.62863 0.58174 1.724 0.44643 3.5731-1.1225 8.8158-5.931 19.819-4.7457 10.859-7.7127 16.087-9.1308 16.087-0.15461 0-0.91588-1.1535-1.6917-2.5633z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.0667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m202.77 94.229c-1.0088-1.885-1.154-6.7556-1.3159-44.157l-0.16592-38.317 2.3917 0.25613c1.3154 0.14087 2.5768 0.32716 2.803 0.41397 0.54121 0.20768 0.95907 55.739 0.52986 70.416-0.3414 11.674-0.4323 12.089-2.6511 12.089-0.85112 0-1.3295-0.21051-1.5917-0.70041z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.4667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m269.54 94.908c-3.7258-0.88168-7.5544-3.3654-9.0061-5.8425-2.434-4.1533-2.89-8.5019-3.1972-30.49l-0.2355-16.857-3.2184-3.3922c-3.7006-3.9004-4.9334-5.8086-4.0952-6.3385 0.29125-0.18412 0.88199-0.3372 1.3127-0.34017 0.93008-0.0064 2.9797-1.7232 3.9403-3.3005 1.3601-2.2331 1.8957-4.6384 2.3298-10.462 0.42001-5.6344 0.46031-5.8261 1.3939-6.6291 1.2118-1.0423 2.1885-1.0535 2.7423-0.03143 0.25156 0.46423 0.53595 3.169 0.68293 6.4954 0.31057 7.0284 0.55996 7.675 4.701 12.189 1.6768 1.8279 3.0487 3.5763 3.0487 3.8853s-1.7899 2.3108-3.9775 4.4484l-3.9775 3.8866 0.23392 9.5172c0.12865 5.2345 0.34496 14.375 0.48069 20.312l0.24677 10.795 3.5386 2.9938c3.832 3.2421 6.8447 6.3528 7.4595 7.7021 0.71842 1.5768-1.2073 2.2142-4.4038 1.4578z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.66667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m229.04 94.927c-1.2054-0.48613-1.5238-1.4597-1.9371-5.9216-0.38604-4.1678-0.14582-51.39 0.27945-54.934 0.32246-2.6872 2.399-3.0929 3.9233-0.76659 0.89947 1.3728 1.1824 15.352 0.78925 38.997-0.31194 18.761-0.49378 22.627-1.0642 22.627-0.15212 0-0.48847 0.0696-0.74744 0.15467-0.25897 0.08507-0.81843 0.01449-1.2432-0.15683z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.66667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m228.09 14.226c-0.79288-0.58783-0.50491-2.0047 0.4207-2.0698 1.5916-0.11208 3.3963 1.0943 2.6914 1.7991-0.63189 0.63189-2.4157 0.78707-3.1121 0.27074z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m299.08 93.28c-1.8088-0.74395-4.4346-2.6141-5.4234-3.8625-1.5883-2.0054-2.4482-4.3661-3.0205-8.2923-1.0673-7.3217-0.98191-33.365 0.12534-38.234 1.2427-5.4635 9.3555-12.048 12.103-9.8236 0.90009 0.72886 0.4381 1.5948-2.5339 4.7497-4.2425 4.5036-5.1427 6.772-5.7341 14.45-0.33868 4.3967-0.15417 21.513 0.26256 24.357 0.83075 5.669 2.018 8.3852 5.1101 11.69 2.8452 3.0413 3.4311 4.2468 2.5111 5.1668-0.55067 0.55067-1.7419 0.47981-3.4002-0.20228z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.0667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m326.08 43.383c-1.7253-1.5377-4.2732-4.5641-5.6847-6.752-0.81194-1.2586-1.0281-1.8155-0.97045-2.5 0.0711-0.84374 0.11874-0.88386 1.1372-0.95754 2.2628-0.1637 5.9736 2.6384 7.3286 5.534 1.4887 3.1813 1.5869 5.706 0.2281 5.866-0.45186 0.05321-1.0073-0.27113-2.0388-1.1905z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.0667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m319.9 93.716c-1.3241-0.92746 0.054-3.7432 3.4431-7.0348 3.1301-3.04 5.9344-4.6424 7.0653-4.0371 0.70976 0.37985 0.59533 1.8695-0.25778 3.3559-1.3442 2.3421-5.6907 6.559-7.953 7.7159-1.0094 0.51617-1.5608 0.5162-2.2976 1.02e-4z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.0667
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m349.26 94.644c-0.94679-1.8309-1.0101-4.445-0.99384-41.019 0.0166-37.243 0.12879-41.958 1.0145-42.628 1.0124-0.76657 1.5111-0.32498 1.9669 1.7415 0.0895 0.40596 0.26214 3.556 0.38357 7 0.28964 8.2145 0.60189 9.2765 3.5422 12.047 1.6612 1.5652 3.0301 2.2908 4.9644 2.6315 0.80736 0.14221 1.6058 0.42471 1.7743 0.62777 0.52014 0.62673-0.42389 1.9311-3.0322 4.1897-2.7658 2.395-4.0243 4.0818-4.8718 6.5302-1.2862 3.7157-1.684 10.082-2.0227 32.361-0.0888 5.8438-0.245 11.853-0.34708 13.355-0.17328 2.5487-0.23051 2.7683-0.8632 3.3125-0.87528 0.75288-1.0583 0.73493-1.5152-0.1486z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.53333
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m382.62 80.062c-0.01-27.153-0.23872-32.45-1.5108-34.966-0.86123-1.7029-4.2203-4.2219-5.63-4.2219-0.80191 0-1.565-0.70272-1.8406-1.6949-0.14208-0.51157-0.25895-3.2181-0.25972-6.0146l-1e-3 -5.0845 1.0625 0.17531c4.7782 0.78838 9.5286 2.7751 12.743 5.3293 2.1801 1.7325 4.4311 4.2011 5.3201 5.8344 1.5526 2.8527 1.7878 7.2893 2.0222 38.143 0.16718 22.009 0.15981 22.563-0.30059 22.566-0.25959 2e-3 -2.7782 0.16911-5.597 0.37136s-5.3219 0.36936-5.5625 0.37136c-0.41313 3e-3 -0.43792-1.1556-0.44505-20.809zm7.6721 14.265c0.16356-0.66262 0.35959-4.4149 0.45059-8.625 0.19698-9.1131-0.25119-39.382-0.61377-41.452-0.42879-2.4487-1.5846-4.4784-3.8556-6.7712-2.6469-2.6722-3.6889-3.2154-6.1819-3.223-1.5341-0.0047-2.0151 0.08819-2.4375 0.47045-0.82884 0.75009-0.67805 1.7184 0.41125 2.6409 2.5363 2.148 4.86 4.8813 6.3873 7.5134 0.94847 1.6346 1.4434 4.1042 1.6773 8.3694l0.20563 3.75-0.0835-4.125c-0.0575-2.8384-0.21259-4.5929-0.49728-5.625-0.787-2.8532-2.8123-5.8288-6.3125-9.2742-2.1263-2.0931-2.3224-2.5613-1.3014-3.1077 0.24978-0.13368 1.1647-0.2417 2.0331-0.24004 1.207 0.0023 1.8274 0.1451 2.6338 0.60616 2.4933 1.4256 5.0582 4.2003 6.1887 6.6949 1.1512 2.5403 1.2465 4.7633 1.2517 29.196 5e-3 24.799 0.0502 24.032-1.4203 24.203-1.6838 0.19494-1.923-2.1506-2.1875-21.453l-0.20727-15.125 0.0781 16.375c0.0953 19.99 0.17016 20.616 2.444 20.451 1.0228-0.07434 1.0547-0.10411 1.3373-1.249z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m343.88 53.113v-47.512l1.4375 0.13731c0.79063 0.075518 3.125 0.25235 5.1875 0.39296s4.2281 0.32218 4.8125 0.40349l1.0625 0.14784 1e-3 1.2841c8.1e-4 0.70626-0.17904 5.2779-0.39968 10.159-0.22782 5.0404-0.32555 9.8855-0.22618 11.214l0.17497 2.3387 0.74887-0.14978c0.41188-0.08237 2.7179-0.93791 5.1245-1.9012 2.4066-0.96328 4.4333-1.7514 4.5038-1.7514 0.0705 0 0.0802 2.3906 0.0216 5.3125-0.0831 4.1427-0.19467 5.5145-0.50675 6.2299-0.40363 0.92521-1.0672 1.4576-1.8168 1.4576-0.79197 0-3.2374 1.3908-4.5448 2.5848-1.0122 0.92433-1.4173 1.5142-1.717 2.5-0.67315 2.2139-0.84836 10.699-0.6861 33.228l0.15439 21.438h-13.332zm7.3813 41.857c0.3341-0.3605 0.66223-1.0074 0.72919-1.4375 0.067-0.43013 0.24087-7.4758 0.38646-15.657 0.46395-26.072 0.86872-30.542 3.1117-34.37 0.34764-0.59319 1.9434-2.2995 3.5462-3.7919 3.0284-2.8198 3.8151-3.9601 3.342-4.8441-0.14549-0.27186-0.29616-0.49429-0.33482-0.49429-0.76346 0-3.3-0.68814-4.1797-1.1339-1.7189-0.87101-3.864-2.9493-4.6028-4.4592-0.7705-1.5748-1.0284-3.6558-1.3674-11.032-0.30993-6.7434-0.63714-7.8988-2.1308-7.5239-1.251 0.31397-1.3721 0.86414-1.6351 7.4246-0.41684 10.398-0.58814 51.181-0.2645 62.974 0.37185 13.551 0.57094 15 2.0605 15 0.46831 0 0.95021-0.23588 1.339-0.65544z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m405.38 63.5v-35.875h13.75v71.75h-13.75zm6 32.031c0-0.05191-0.19687-0.24879-0.4375-0.4375-0.39651-0.31097-0.40536-0.30212-0.0944 0.09439 0.32659 0.41644 0.53189 0.54887 0.53189 0.34311zm2-0.53061c0.32294-0.34375 0.53091-0.625 0.46216-0.625-0.0687 0-0.38922 0.28125-0.71216 0.625s-0.53091 0.625-0.46216 0.625c0.0687 0 0.38922-0.28125 0.71216-0.625zm1.9156-7.9375c-0.0693-0.17188-0.1261-0.03125-0.1261 0.3125s0.0568 0.48438 0.1261 0.3125 0.0693-0.45312 0-0.625zm-5.9888-4.4971c-0.0598-0.31098-0.111-0.11542-0.11377 0.43458-3e-3 0.55 0.0462 0.80444 0.10872 0.56542 0.0626-0.23902 0.0648-0.68902 5e-3 -1zm5.494-48.737c-0.0798-0.19943-0.13905-0.14019-0.15104 0.15104-0.0109 0.26354 0.0482 0.4112 0.1313 0.32812 0.0831-0.08307 0.092-0.2987 0.0197-0.47917zm-3.8889-1.6406c0.31097-0.39651 0.30212-0.40536-0.0944-0.09439-0.24062 0.18871-0.4375 0.38559-0.4375 0.4375 0 0.20576 0.2053 0.07333 0.53189-0.34311zm2.1504-0.71354c-0.0831-0.08307-0.2987-0.09195-0.47916-0.01974-0.19944 0.07981-0.1402 0.13904 0.15104 0.15104 0.26354 0.01086 0.41119-0.04823 0.32812-0.1313z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.3333
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m410.96 20.611c-3.3706-0.65427-5.8859-3.6396-5.8859-6.9856 0-3.021 1.2338-5.139 3.712-6.372 2.0251-1.0076 4.6167-1.0371 6.463-0.07367 2.5989 1.3562 4.114 3.6839 4.114 6.3205 0 4.3742-4.1985 7.9269-8.4031 7.1108zm3.0768-5.8309c0.72235-0.83978 0.74679-1.6347 0.0765-2.4869-0.99751-1.2681-2.9702-1.123-4.3529 0.3202-0.51099 0.53336-0.6531 0.90279-0.59187 1.5386 0.10863 1.1281 0.89488 1.5211 2.8058 1.4024 1.2354-0.07673 1.5707-0.20263 2.0625-0.77439z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 0.53333
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m409.73 20.361c-1.7605-0.6773-3.1995-1.9918-4.0283-3.6797-0.5893-1.2001-0.69975-1.7337-0.68419-3.3061 0.021-2.1272 0.40411-3.2174 1.6152-4.5967 1.9448-2.215 5.6697-3.045 8.2873-1.8466 2.9034 1.3292 4.5165 3.6563 4.5165 6.5157 0 2.1831-0.76614 3.8566-2.4846 5.4271-2.14 1.9558-4.6556 2.4735-7.2218 1.4862zm3.9852-5.5039c0.92435-0.7271 0.911-1.9965-0.0288-2.7381-1.4981-1.1822-4.3125 0.06792-4.3125 1.9156 0 1.0408 0.48303 1.3233 2.2788 1.333 1.0497 0.0057 1.5699-0.12308 2.0625-0.51054z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.3333
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(7.5 0 0 -7.5 681.5 2046.7)",
    d: "m409.97 14.499c-0.26221-0.68331 0.15622-1.6097 0.90102-1.9949 1.3526-0.69943 2.409-0.43344 3.0924 0.77857 0.0878 0.15571-0.072 0.57759-0.35512 0.9375-0.45233 0.57504-0.69535 0.65438-2.0044 0.65438-1.0945 0-1.5279-0.09962-1.6338-0.37556z",
    fill: "#00004d",
    stroke: "#00004d",
    strokeMiterlimit: 2.1,
    strokeWidth: 1.6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.74939 0 0 .74939 -191.26 -190.77)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0149 0 0 1.0064 78.327 132.7)",
    d: "m214.4 205.95-28.53-29.768 40.044-9.8237z",
    fill: "url(#b)",
    stroke: "url(#b)",
    strokeLinejoin: "round",
    strokeWidth: 3.9578
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0149 0 0 1.0064 96.084 114.82)",
    d: "m214.4 205.95-28.53-29.768 40.044-9.8237z",
    fill: "url(#g)",
    stroke: "url(#f)",
    strokeLinejoin: "round",
    strokeWidth: 3.9578,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.89,
    cy: 303.74,
    rx: 45.098,
    ry: 45.122,
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeWidth: 5,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0149 0 0 1.0064 111.88 160.93)",
    d: "m217.39 142.68-28.53-29.768 40.044-9.8237z",
    fill: "url(#c)",
    stroke: "url(#c)",
    strokeLinejoin: "round",
    strokeWidth: 3.9578
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8db0b0316ed9a217c220642e13cbb30a.svg";
export { ForwardRef as ReactComponent };